import React, { useEffect, useState, useRef, useContext } from "react";
import "./App.scss";

import TitlePage from "./components/TitlePage/TitlePage";
import DescPage from "./components/DescPage/DescPage";
import PortfolioPage from "./components/PortfolioPage/PortfolioPage";
import { storage } from "./Firebase";
import { getDownloadURL, ref, getMetadata, getBlob } from "firebase/storage";
import { useDataContext } from "./contexts/Context";
import VanillaTilt from "vanilla-tilt";
import axios from "axios";
import ReactPaginate from "react-paginate";

export default function App() {
  const { img, setUrl, setLoading, setData, setCards } = useDataContext();
  const options = {
    reverse: true,
    reset: false,
  };

  useEffect(() => {
    const element = document.querySelectorAll(".card");
    VanillaTilt.init(element, options);
  }, []);

  useEffect(() => {
    setLoading(true);

    const fileRef = ref(storage, "projects.json");

    getDownloadURL(fileRef).then((response) => {
      axios.get(response).then((response) => {
        setUrl(response.data[img]?.photo);
        setData(response.data[img]);
        setCards(Object.getOwnPropertyNames(response.data));
        setLoading(false);
      });
    });
  }, [img]);
  return (
    <div style={{ maxWidth: "100vw", overflowX: "hidden" }}>
      <TitlePage />
      <PortfolioPage />
    </div>
  );
}
